import { Fragment, useState } from 'react';
import { useFeatureFlag } from 'shared/domains/featureFlag';
import { MetadataOverviewCard } from './MetadataOverviewCard';
import { SendToHubspotDialog } from './SendToHubspotDialog';
import { useHubspotMetadataOverviewMock } from './useHubspotMetadataOverviewMock';
export function HubspotMetadataSync() {
    const hubspotMetadataSyncEnabled = useFeatureFlag('feature_hubspot_metadata_sync');
    const { hasConfiguration, lastSync } = useHubspotMetadataOverviewMock();
    const [syncDialogOpen, setSyncDialogOpen] = useState(false);
    if (!hubspotMetadataSyncEnabled || !hasConfiguration) {
        return null;
    }
    return (<Fragment>
      <MetadataOverviewCard lastSync={lastSync} onOpenSyncDialog={() => {
            setSyncDialogOpen(true);
        }}/>
      {syncDialogOpen && <SendToHubspotDialog onClose={() => setSyncDialogOpen(false)}/>}
    </Fragment>);
}
